export const state = () => ({
  automationId: null,
  loading: false,
})

export const mutations = {}

export const actions = {}

export const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
